<template>
  <div class="crooked-container">
    <!-- Custom-shaped div for image -->
    <div class="image-shape">
      <img src="../../../assets/images/wasyyah_logo.jpeg" alt="Contact Us" class="contact-image" />
    </div>
    <LoadingOverlay :active="isLoading" :is-full-page="true" color="#077747" loader="dots" />
    <!-- Contact Form Section -->
    <div class="contact-form-section">
      <form @submit.prevent="onSubmit" @reset.prevent="onReset" class="contact-form">
        <!-- Form Title -->
        <h2 class="form-title">{{ $t('Get In Touch') }}</h2>

        <!-- Form Fields -->
        <div class="form-group">
          <input type="text" v-model="formData.name" placeholder="Your Name" required />
        </div>
        <div class="form-group">
          <input type="number" v-model="formData.mobile" maxlength="11" placeholder="Your Phone No" required />
        </div>
        <div class="form-group">
          <input type="email" v-model="formData.email" placeholder="Your Email" required />
        </div>
        <div class="form-group">
          <textarea v-model="formData.message" placeholder="Your Message" rows="4" required></textarea>
        </div>

        <!-- Contact Info Columns -->
        <div class="row contact-info">
          <div class="col-md-6 contact-info-item">
            <div class="info-box" @mouseenter="hoverEffect(true)" @mouseleave="hoverEffect(false)">
              <i class="fas fa-phone-alt"></i> +123 456 7890
            </div>
          </div>
          <div class="col-md-6 contact-info-item">
            <div class="info-box" @mouseenter="hoverEffect(true)" @mouseleave="hoverEffect(false)">
              <i class="fas fa-envelope"></i> contact@example.com
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="button-container">
          <button type="submit" class="submit-btn">Send Message</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiRepository from '@/services/apiRepository';
import { toast } from "vue3-toastify";

export default {
  data() {
    return {
      isLoading: false,
      formData: {
        name: '',
        mobile: '',
        email: '',
        message: ''
      },
      hover: false
    };
  },
  methods: {
    hoverEffect(state) {
      this.hover = state;
    },
    onSubmit() {
      const toastId = toast.info('Sending your Email to Wasiyyat Authority...', {
        autoClose: 13000, // Prevent auto-closing
        closeButton: false, // Hide the close button
      });
      apiRepository.callApi(apiRepository.POST_COMMAND, `/contactUsEmailSend`, this.formData).then(res => {
        try {

          if (res.data) {
            toast.update(toastId, {
              render: res.data,
              type: "success",
              autoClose: 5000, // Close after 5 seconds
              closeButton: true,
            });
            toast.success(res.data);
            this.onReset();
          } else {
            toast.error('Something went wrong!', { autoClose: 5000 });
            this.onReset();
          }
        } catch (error) {
          console.error('Error occurred during API call:', error);
          // toast.error (error.response.data);
        }

      })
    },
    onReset() {
      this.formData = {
        name: '',
        mobile: '',
        email: '',
        message: ''
      }
    }
  }

};
</script>

<style scoped>
/* Main container with custom shape */
.crooked-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient(135deg, #077747 50%, #ffffff 50%);
  padding: 50px 0;
  clip-path: polygon(0 0, 100% 0, 100% 80%, 0% 100%);
  position: relative;
  margin-top: 30px;
  z-index: 100;
}

/* Image shape and styling */
.image-shape {
  position: absolute;
  top: -10px;
  width: 120px;
  height: 80px;
  overflow: hidden;
  border-radius: 10px;
  background-color: rgba(163, 163, 163, 0.2);
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: inherit;
}

/* Contact Form */
.contact-form-section {
  width: 100%;
  max-width: 600px;
  background: white;
  border-radius: 15px;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.1);
  padding: 20px 30px;
}

.form-title {
  text-align: center;
  color: #077747;
  font-size: 24px;
  margin-bottom: 20px;
}

.form-group input,
.form-group textarea {
  width: 100%;
  padding: 12px;
  margin: 8px 0;
  border-radius: 10px;
  border: 1px solid #ddd;
  outline: none;
  transition: box-shadow 0.3s;
}

.form-group input:focus,
.form-group textarea:focus {
  box-shadow: 0 0 8px rgba(7, 119, 71, 0.3);
}

/* Contact Info Boxes */
.contact-info {
  display: flex;
  gap: 15px;
  margin: 20px 0;
}

.contact-info-item {
  display: flex;
  justify-content: center;
  flex: 1;
}

.info-box {
  background-color: #f9f9f9;
  padding: 10px 20px;
  border-radius: 10px;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1);
  font-size: 16px;
  text-align: center;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  color: #333;
}

.info-box:hover {
  transform: translateY(-5px);
  box-shadow: 0px 8px 15px rgba(7, 119, 71, 0.2);
  color: #077747;
}

/* Submit Button */
.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.submit-btn {
  background-color: #077747;
  color: white;
  border: none;
  padding: 12px 30px;
  font-size: 16px;
  border-radius: 10px;
  cursor: pointer;
  transition: transform 0.3s, box-shadow 0.3s;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
}

.submit-btn:hover {
  transform: translateY(-5px);
  box-shadow: 0px 8px 15px rgba(7, 119, 71, 0.3);
}
</style>
